import { render, staticRenderFns } from "./headOther.vue?vue&type=template&id=aee987f6&scoped=true"
import script from "./headOther.vue?vue&type=script&lang=js"
export * from "./headOther.vue?vue&type=script&lang=js"
import style0 from "./headOther.vue?vue&type=style&index=0&id=aee987f6&prod&lang=css"
import style1 from "./headOther.vue?vue&type=style&index=1&id=aee987f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee987f6",
  null
  
)

export default component.exports